export type DictationMode = "dictation" | "organize";

export const DICTATION_MODE_STORAGE_KEY = "iloris:dictation-mode:v1";

export function loadDictationMode(): DictationMode {
    if (
        typeof localStorage === "undefined" ||
        typeof localStorage.getItem !== "function"
    ) {
        return "dictation";
    }
    return localStorage.getItem(DICTATION_MODE_STORAGE_KEY) === "organize"
        ? "organize"
        : "dictation";
}

export function saveDictationMode(mode: DictationMode): void {
    if (
        typeof localStorage !== "undefined" &&
        typeof localStorage.setItem === "function"
    ) {
        localStorage.setItem(DICTATION_MODE_STORAGE_KEY, mode);
    }
}
